import React from 'react';
import Select from 'react-select'; // Assuming the Select component is from a library like react-select
import { DROPDOWN_STYLE, wordingOptions } from './constants';
import SingleOption from './SingleOption';
import SingleChoiceDropdown from './SingleChoiceDropdown';
import SpringBehalfContactForm from './SpringBehalfContactForm';


class SpringBehalfForm extends React.Component {
  render() {
    const {
      formData,
      setFormData,
      handleInputChange,
      toggleValue,
      handleChoiceUpdate
    } = this.props; // Destructure props

    return (
      <>
        <SingleChoiceDropdown 
            value={formData.behalf}
            toggleValue={(e) => toggleValue(e, "behalf")} 
            label={"Is this gift in honour of someone?"}
            identifier="behalf"
            outerClass="col-md-12"
        />

        {formData.behalf && (<SpringBehalfContactForm
                        formData={formData}
                        handleInputChange={handleInputChange}
                        toggleValue={toggleValue}
                        handleChoiceUpdate={handleChoiceUpdate}
        />)}


      </>
    );
  }
}

export default SpringBehalfForm;
